import axios from "axios";
import dictionary from "../dictionary";
const apiHost = dictionary.apiHost;
const WHITELIST = [
  "login",
  "/Activate/account",
  // ,"/signup", "/forgot-password"
];
const apiCall = async (endpoint, data) => {
  const ACCESS_TOKEN = localStorage.getItem("FuelFy@daisy");
  const isWhitelisted = WHITELIST.includes(endpoint);
  if (!isWhitelisted && !ACCESS_TOKEN) {
    let connError = {
      status: "Fail",
      details: {
        message: "⛔ Unauthorized access! Login required!",
        content: false,
      },
    };
    return connError;
  }
  try {
    let response = await axios.post(apiHost + endpoint, data, {
      headers: {
        Authorization: ACCESS_TOKEN ? "Bearer " + ACCESS_TOKEN : undefined,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    let connError = {
      status: "Fail",
      message: "Server connection error occurred!",
      details: { message: "Contacting server....", content: false },
    };
    return connError;
  }
};
export default apiCall;
